import { functions } from '../utils/firebase';
import { httpsCallable } from 'firebase/functions';

export const generateAIContent = async (prompt: string, isJson?: boolean): Promise<string> => {
  try {
    const generateFn = httpsCallable<{prompt: string, isJson?: boolean}, {text: string}>(functions, 'generateAIContent');
    const result = await generateFn({ prompt, isJson });
    return result.data.text;
  } catch (error) {
    console.error("Error calling AI function:", error);
    throw error;
  }
};
